export const sizes = {
  md: "w-[26.25rem]",
  lg: "w-[40.625rem]",
  full: "w-[100vw]"
};

export const animate = {
  initial: { right: "-100%" },
  animate: { right: 0 },
};
